import {zodResolver} from '@hookform/resolvers/zod'
import {
    loginField,
    loginFieldValidation,
    twoFactorField,
    twoFactorFieldValidation,
} from 'constants/FormField/loginField'
import useResponsive from 'logic/useResponsive'
import {useState} from 'react'
import {useForm} from 'react-hook-form'
import {useTranslation} from 'react-i18next'
import {toast} from 'sonner'
import {useLoginMutation, useVerifyTwoFactorMutation} from 'store/Store'

const useLogin = ({i18nCategory}) => {
    const {mediumScreen} = useResponsive()
    const {t} = useTranslation()
    const [step, setStep] = useState('login')
    const [pendingEmail, setPendingEmail] = useState('')

    const loginMethods = useForm({resolver: zodResolver(loginFieldValidation)})
    const twoFactorMethods = useForm({resolver: zodResolver(twoFactorFieldValidation)})

    const [doLogin, {error: loginError}] = useLoginMutation()
    const [doVerifyTwoFactor, {error: twoFactorError}] = useVerifyTwoFactorMutation()

    const onLoginSubmit = (data) => {
        toast.promise(
            doLogin(data)
                .unwrap()
                .then((res) => {
                    if (res?.isTwoFactorAuth) {
                        setPendingEmail(data.email)
                        setStep('two_factor')
                    }
                })
                .catch((error) => {
                    throw error
                }),
            {
                loading: t('loading'),
                success: (res) =>
                    res?.isTwoFactorAuth ? t('two_factor.codeSent') : t(`${i18nCategory}.success`),
                error: () => t(`${i18nCategory}.error`),
            }
        )
    }

    const onTwoFactorSubmit = (data) => {
        toast.promise(
            doVerifyTwoFactor({email: pendingEmail, code: data.code})
                .unwrap()
                .catch((error) => {
                    throw error
                }),
            {
                loading: t('loading'),
                success: () => t(`${i18nCategory}.success`),
                error: () => t('two_factor.error'),
            }
        )
    }

    if (step === 'two_factor') {
        return {
            handleSubmit: twoFactorMethods.handleSubmit,
            onSubmit: onTwoFactorSubmit,
            error: twoFactorError,
            mediumScreen,
            methods: twoFactorMethods,
            t,
            formField: twoFactorField,
            step,
        }
    }

    return {
        handleSubmit: loginMethods.handleSubmit,
        onSubmit: onLoginSubmit,
        error: loginError,
        mediumScreen,
        methods: loginMethods,
        t,
        formField: loginField,
        step,
    }
}

export default useLogin
